import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'

import { ChangePasswordPayload } from './types'

export const changePassword = async (values: ChangePasswordPayload) => {
  return wretchClient
    .url('/admin/1.0/operators/password')
    .put(values)
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
